import { IconButton, InputAdornment, TextField, WithStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import * as React from "react";
import { PasswordValidator, RuleNames } from "../PasswordValidator/PasswordValidator";
import { styles } from "./FormPasswordField.styles";
import configuration from "../../../utilities/configuration";

export interface IValidateParams {
    onChangeValid?: any;
    passwordToMatch?: string;
}

export interface IFormPasswordFieldProps extends WithStyles<typeof styles> {
    id?: string;
    label: string;
    password: string;
    onChange?: any;
    rules?: Array<RuleNames>;
    showPassword?: boolean;
    onChangeShowPassword?: any;
    validateParams?: IValidateParams;
    error?: boolean;
    helperText?: string | React.ReactNode;
    disabled?: boolean;
    className?: string;
}

const FormPasswordFieldPure: React.FunctionComponent<IFormPasswordFieldProps> = ({
    id,
    label,
    password,
    onChange,
    rules,
    showPassword,
    onChangeShowPassword,
    validateParams,
    error,
    helperText,
    disabled,
    className,
    classes
}: IFormPasswordFieldProps) => {
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    let helperTextToRender = helperText;

    if (validateParams && password !== "")
        helperTextToRender = <PasswordValidator
                rules={rules}
                minLength={configuration?.cognitoPasswordMinimumLength}
                password={password}
                passwordConfirm={validateParams?.passwordToMatch}
                onChange={isValid => validateParams?.onChangeValid(id, isValid)}
            />

    return (
        <div className={className}>
            <TextField
                className={classes.inputField}
                error={error}
                fullWidth={true}
                variant="outlined"
                label={label}
                InputLabelProps={{
                    shrink: true
                }}
                type={showPassword ? "text" : "password"}
                onChange={onChange}
                disabled={disabled}
                id={id}
                name={id}
                value={password}
                InputProps={{
                    endAdornment: (
                         <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={onChangeShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                className={classes.adornmentIcon}
                            >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </InputAdornment>
                    )
                }}
                helperText = {helperTextToRender}
            />
        </div>
    );
};

export const FormPasswordField = withStyles(styles)(FormPasswordFieldPure);
